export { DocumentacionContainer } from "./guias/documentacion/index";
export { Cotizador } from "./cotizador/index";
export { EntregaOcurre } from "./ocurre/index";
export { FirmaRemotaIndex } from "./firmaremota/index";
export { QRIndex } from "./qr/index";
export { guiaColumnasFijas, DocumentacionList, GuiaList, GuiaListMem, GuiasIndex, DocumentacionesIndex } from "./guias";
export { MovimientosCajaIndex } from "./movimientoscajaruta/index";
export { MovimientosCamionIndex } from "./movimientoscamion/index";
export { ViajesIndex } from "./viajes";
export { Enrutamiento } from "./enrutamiento";
export * from "./cargacajaruta";
export * from "./cobranza";
export { FacturaIndex } from "./facturas/index";
export { GuiasAFacturarIndex } from "./facturarguias/index";
export { FacturarGuiasPublicoGeneralIndex } from "./facturapublico/index";
export { TurnoCatalogo } from "./turnos";
export { ViajeEADIndex } from "./viajesEAD";
export { CargasDescargasEADIndex } from "./cargasEAD";
export { CorteVentaIndex } from "./corteventas";
export { ViajeAppIndex } from "./viajeapp";
export { MovimientoCajaViewCatalogo } from "./movimientoscaja";
export { ConsultaCamionEAD } from "./consultaEAD";
export { CorteDiarioCatalogo } from "./cortediario";
export { ConsultaPolizascontables } from "./polizas";
export { RastreoGuiasIndex } from "./rastreo";
export { ManifiestoRAD } from "./manifiestorad";
export { FacturacionOnlineIndex } from "./facturaciononline";
export { DepositoBancoIndex } from "./depositobanco";
export { ReporteComportamientoComercial } from "./reportecomportamientocomercial";
export { ReporteCobranzaSemanal } from "./reportecobranzasemanal";
export { ReporteGuiasEnviadasRecibidas } from "./reporteguiasenviadasrecibidas";
export { ReporteSeguimientoVentas } from "./reporteseguimientoventas";
export { ReporteEstadisticasClientes} from "./reporteestadisticasclientes";
export { ReporteSaldosCartera} from "./reportesaldocartera";
export { ReporteLibroAdministracion} from "./reportelibroadministracion";
export { EnviosCanalComercializacion } from "./reporteenvioscanalcomercializacion";
export { EficienciaEAD } from "./reporteeficienciaead";
export { ReporteDiarioVenta } from "./reportediarioventa";
export { AntiguedadSaldosIndex } from "./reporteantiguedadsaldos";
export { EstadoCuentaIndex } from "./reporteestadodecuenta";
export { CorteIngresosZEIndex } from "./corteingresosZE";
export { EntregaIngresoIndex } from "./entregaingresoZE"
export { CargaZEIndex } from "./cargasze";
export { ReporteConteoGuiaEditComp } from "./reporteconteoguia";
export { ResumenChoferZE } from "./resumenchoferze";
export { PaquetesPPIndex } from "./paquetespp";
export { PartidaAclaracionIndex } from "./partidasaclaracion";
export { ReportePartidasAclaracion } from "./reportepartidasaclaracion";
export { ReporteVentasPP } from "./reporteventapp";
export { ReportePaquetesPP } from "./reportepaquetepp";
export { ConsultaVehiculoZE } from "./consultaZE";
export { ViajeAppZE } from "./viajeappZE";
export { ViajeZEIndex } from "./viajesZE";
export { EntregasZERealizadasIndex } from "./entregasZERealizadas";
export { LiberacionesZEIndex } from "./liberacionentregasZE";
export { DescargaZEIndex } from "./descargaze";
export { SaldosUsuariosZEIndex } from "./actividadesusuariosze";
export { ConsultaGuiasSucursalZEIndex } from "./consultaguiasentregarze";
export { ReporteGuiasDoc } from "./reporteguiasdoc";
export { ReporteConsultaGuias } from "./reporteconsultaguias";
export { BitacoraRAD } from "./bitacoraRAD";
export { ConsultaMovimientosCargaIndex } from "./consultaMovimientosCarga";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/index.tsx